<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="signup">
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>新規会員登録</h2>
            <p>
              以下フォームに、お客様のメールアドレスを入力し仮登録を行ってください。<br>
              本会員登録手続きのご案内メールをお送りいたしますので、メール内にURLより本登録をお願いします。
            </p>
            <div class="signup_form">
              <label>ご登録メールアドレス</label>
              <input type="text" v-model.trim="mailAddress" placeholder="メールアドレスを入力してください。">
              <div class="detail_btn btn_pos_left" @click="sendMail()">仮登録する</div>
              <div v-if="errors.email" class="error_text">{{errors.email}}</div>
              <div class="error_text">{{ errorMessage.text }}</div>
              <p>
                ※ 受信制限をされている方は、「@domans.co.jp」からのメールを受信許可に設定してください。<br>
                ※ メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。
              </p>
            </div>
          </section>
          <!-- <section>
            <h2>会員登録するとこんなに便利！</h2>
            <ul class="ul_user_register">
              <li>
                <h3>①会員限定価格での商品購入</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>②メールマガジンでお得な情報をお届け</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>③カスタマイズ情報の保存</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>④ご注文時の情報入力がスムーズに</h3>
                <p>ここに説明文が入ります。</p>
              </li>
            </ul>
          </section> -->
          <!-- <section>
            <h2>法人会員様は更に便利！</h2>
            <p>
              法人・個人事業主様の場合、前述のメリットに加えて以下の特典がございます。（法人会員の発行には所定の審査がございます。）
            </p>
            <ul class="ul_user_register">
              <li>
                <h3>① 法人会員限定価格での商品購入</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>② 掛け払いの利用申請が可能</h3>
                <p>ここに説明文が入ります。</p>
              </li>
              <li>
                <h3>③ オーダー家具営業ノウハウのご提供</h3>
                <p>ここに説明文が入ります。</p>
              </li>
            </ul>
          </section> -->
          <!-- <section>
            <h2>新規会員登録</h2>
            <p>
              以下フォームに、お客様のメールアドレスを入力し仮登録を行ってください。<br>
              本会員登録手続きのご案内メールをお送りいたしますので、メール内にURLより本登録をお願いします。
            </p>
            <div class="signup_form">
              <label>ご登録メールアドレス</label>
              <input type="text" v-model.trim="mailAddress" placeholder="メールアドレスを入力してください。">
              <div class="detail_btn btn_pos_left" @click="sendMail()">仮登録する</div>
              <div v-if="errors.email" class="error_text">{{errors.email}}</div>
              <div class="error_text">{{ errorMessage.text }}</div>
              <p>
                ※ 受信制限をされている方は、「@domans.co.jp」からのメールを受信許可に設定してください。<br>
                ※ メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。
              </p>
            </div>
          </section> -->
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as Check from '../../utils/Check'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'

import DcHeader from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': Footer,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcSignUp',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'signup', key: 'dcSignUp', title: '新規会員登録', route: 'DcSignUp'}
      ],
      mailAddress: '',
      paramForm: {},
      errors: {},
      errorMessage: { text: '' },
      submitDisable: false
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    sendMail: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)

      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)

      let payload = {
        mailAddress: this.mailAddress,
        inviteCode: this.paramForm.code,
        payment: this.paramForm.payment
      }
      axios.post(DC_URL.USER + '/new/user', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
            App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
            App.removeLocalStorage(DC_STORAGE_KEY.USER_TYPE)
            this.$router.push('/user/mail-comp')
          }
        }).catch(error => {
          this.errorMessage.text = error.response.data.errorMessage
        })
        .finally(() => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        })
    },
    validatedReqire: function () {
      if (!Check.isMail(this.mailAddress)) {
        this.errors['email'] = 'メールアドレスが正しくありません。'
      }
    }
  },
  created: function () {
    if (this.$route.query.code) {
      this.paramForm = {
        code: this.$route.query.code,
        payment: this.$route.query.payment
      }
      App.setLocalStorage(DC_STORAGE_KEY.INVITE_CODE, this.paramForm)
    } else {
      let lparam = App.getLocalStorage(DC_STORAGE_KEY.INVITE_CODE)
      if (lparam && Object.keys(lparam).length > 0) {
        this.paramForm = lparam
      }
    }
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcSignUp.vue